// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","button":"linkText-module__button___13Tcl","buttonWrapper":"linkText-module__buttonWrapper___7-AtW"};